import notificationConstants from "../_constants/notificationConstants";
import { firestore, auth } from "../_firebase";
import Collection from "../_collections";
import { showToast } from "./appActions";
import notificationsService from "../_services/notificationsService";

/* ---------------------------------------------------
 LISTENING FOR NEW NOTIFICATION
----------------------------------------------------- */

export const listeningForNewNotification = payload => dispatch => {
  const { history } = payload;
  const userId = auth.currentUser.uid;

  const unsubscribeNotifications = firestore
    .collection(Collection.USERS)
    .doc(userId)
    .collection(Collection.NOTIFICATIONS)
    .where("read", "==", false)
    .orderBy("createdAt", "desc")
    .onSnapshot(
      {
        // Listen for document metadata changes
        includeMetadataChanges: false
      },
      notifications => {
        notifications.docChanges().forEach(notification => {
          if (notification.type === "added") {
            const data = notification.doc.data();
            dispatch(
              showToast({
                type: "image",
                title: data.user.name,
                message: data.message,
                image: data.user.imageURL,
                timeout: 0,
                onClick: () => {
                  if (
                    data.type ===
                    notificationConstants.NOTIFICATION_TYPE_PROFILE_VIEW
                  ) {
                    history.push(`/view-profile/${data.user.id}`);
                  } else if (
                    data.type ===
                    notificationConstants.NOTIFICATION_TYPE_CONNECT_REQUEST
                  ) {
                    history.push(`/accept-invitations`);
                  } else if (
                    data.type ===
                    notificationConstants.NOTIFICATION_TYPE_CONNECT_APPROVED
                  ) {
                    history.push(`/view-profile/${data.user.id}`);
                  }
                },
                onClose: () => {
                  dispatch(markNotificationAsRead(notification.doc.id));
                }
              })
            );
          }
        });
      }
    );

  return unsubscribeNotifications;
};

/* ---------------------------------------------------
  LISTENING FOR NEW NOTIFICATION SUCCESS
----------------------------------------------------- */
const listeningForNewNotificationSuccess = payload => ({
  type: notificationConstants.LISTENING_FOR_NEW_NOTIFICATION,
  payload
});

/* ---------------------------------------------------
 MARK NOTIFICATION AS READ
----------------------------------------------------- */

export const markNotificationAsRead = notificationId => dispatch => {
  notificationsService
    .markNotificationAsRead(notificationId)
    .then(() => {
      dispatch(markNotificationAsReadSuccess());
    })
    .catch(() => {
      //do nothing
    });
};

/* ---------------------------------------------------
  MARK NOTIFICATION AS READ SUCCESS
----------------------------------------------------- */
const markNotificationAsReadSuccess = payload => ({
  type: notificationConstants.MARK_NOTIFICATION_AS_READ,
  payload
});

/* ---------------------------------------------------
 GET NOTIFICATIONS LIST
----------------------------------------------------- */

export const getNotificationsList = payload => dispatch => {
  notificationsService
    .getNotifications()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getNotificationsListSuccess(results));
      if (results.length < 10) {
        dispatch(changeNotificationLastResult(null));
      } else {
        dispatch(changeNotificationLastResult(lastResult));
      }
    })
    .catch(() => {
      dispatch(getNotificationsListSuccess([]));
      dispatch(changeNotificationLastResult(null));
    });
};

/* ---------------------------------------------------
  GET NOTIFICATIONS LIST SUCCESS
----------------------------------------------------- */
const getNotificationsListSuccess = payload => ({
  type: notificationConstants.GET_NOTIFICATIONS_LIST,
  payload
});

/* ---------------------------------------------------
 CHANGE NOTIFICATION LAST RESULT
----------------------------------------------------- */
const changeNotificationLastResult = payload => ({
  type: notificationConstants.CHANGE_NOTIFICATION_LAST_RESULT,
  payload
});

/* ---------------------------------------------------
 GET NOTIFICATIONS LIST
----------------------------------------------------- */

export const loadMoreNotifications = payload => dispatch => {
  const { lastResult } = payload;
  notificationsService
    .loadMoreNotifications(lastResult)
    .then(response => {
      const { results, lastResult } = response;
      dispatch(loadMoreNotificationsSuccess(results));
      dispatch(changeNotificationLastResult(lastResult));
    })
    .catch(() => {
      dispatch(loadMoreNotificationsSuccess([]));
      dispatch(changeNotificationLastResult(null));
    });
};

/* ---------------------------------------------------
  LOAD MORE NOTIFICATIONS SUCCESS
----------------------------------------------------- */
const loadMoreNotificationsSuccess = payload => ({
  type: notificationConstants.LOAD_MORE_NOTIFICATIONS,
  payload
});

/* ---------------------------------------------------
 MARK ALL NOTIFICATIONS AS READ
----------------------------------------------------- */

export const markAllNotificationsAsRead = payload => dispatch => {
  notificationsService
    .markAllAsRead()
    .then(response => {
      dispatch(markAllNotificationsAsReadSuccess());
    })
    .catch(() => {
      //nothing
    });
};

/* ---------------------------------------------------
  MARK ALL NOTIFICATIONS AS READ SUCCESS
----------------------------------------------------- */
const markAllNotificationsAsReadSuccess = payload => ({
  type: notificationConstants.MARK_ALL_NOTIFICATIONS_AS_READ,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/notificationActions.js